import type { CurrencyDisplayConfig } from '../../currencyDisplay.types.ts';

const CURRENCY_DISPLAY = {
  prizeTableNumberFormat: 'currency_optional_decimals',
} satisfies CurrencyDisplayConfig;

export { CURRENCY_DISPLAY };
